import { Link } from "react-router-dom";
import { Truck, ShieldCheck, CreditCard, Mail } from "lucide-react";
import { CONTACTS } from "@/components/shop/Brand";
import { GAME_PAGES, COMPANY } from "@/lib/constants";
import { SocialLinks } from "@/components/shop/Socials";
import { openConsent } from "@/components/shop/ConsentGate";
import { useContent } from "@/lib/content";
import { useShippingConfig, promoSummary } from "@/lib/shipping";

const ShipSummary = () => promoSummary(useShippingConfig());

const FooterPages = () => {
  const pages = (useContent("/pages", []) || []).filter((p) => p.in_footer);
  return (
    <>
      <p className="mb-3 mt-6 font-display font-semibold">Card Source</p>
      <ul className="space-y-2 text-sm text-stone-600" data-testid="footer-pages">
        <li><Link to="/news" className="hover:text-amber-600" data-testid="footer-news">News</Link></li>
        {pages.map((p) => <li key={p.id}><Link to={`/pagina/${p.slug}`} className="hover:text-amber-600" data-testid={`footer-page-${p.slug}`}>{p.title}</Link></li>)}
      </ul>
    </>
  );
};

export const Footer = () => (
  <footer className="mt-24 border-t border-black/10 bg-[#F6E7CB]">
    <div className="card-stripes h-1.5" />
    <div className="mx-auto grid max-w-[1440px] gap-10 px-4 py-14 sm:px-6 md:grid-cols-5 lg:px-12">
      <div className="md:col-span-2">
        <img src="/brand/logo.png" alt="Card Source - La tua fonte di sigillati TCG" className="h-32 w-auto" data-testid="footer-logo" />
        <p className="mt-4 max-w-md text-sm text-stone-600">Rivendita all'ingrosso e al dettaglio di prodotti sigillati TCG, compravendita di carte singole, pre-grading, eventi e tornei ufficiali.</p>
        <div className="mt-6 flex flex-wrap gap-4 text-xs text-stone-600">
          <span className="flex items-center gap-2" data-testid="footer-shipping-summary"><Truck className="h-6 w-6 shrink-0 text-amber-600" /><span>Spedizioni <ShipSummary /></span></span>
          <span className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-cyan-600" />Spedizione protetta</span>
          <span className="flex items-center gap-2"><CreditCard className="h-4 w-4 text-violet-500" />Carta, PayPal, Bonifico</span>
        </div>
      </div>
      <div>
        <p className="mb-3 font-display font-semibold">Giochi</p>
        <ul className="space-y-2 text-sm text-stone-600">
          {GAME_PAGES.map((g) => <li key={g.slug}><Link to={`/gioco/${g.slug}`} className="hover:text-amber-600" data-testid={`footer-game-${g.slug}`}>{g.name}</Link></li>)}
          <li><Link to="/catalogo" className="hover:text-amber-600">Tutto il catalogo</Link></li>
        </ul>
        <p className="mb-3 mt-6 font-display font-semibold">Aiuto</p>
        <ul className="space-y-2 text-sm text-stone-600">
          <li><Link to="/assistenza#faq" className="hover:text-amber-600" data-testid="footer-faq">Assistenza e FAQ</Link></li>
          <li><Link to="/spedizioni" className="hover:text-amber-600" data-testid="footer-shipping">Spedizioni e resi</Link></li>
          <li><Link to="/traccia" className="hover:text-amber-600" data-testid="footer-track">Traccia la tua spedizione</Link></li>
          <li><Link to="/b2b" className="hover:text-amber-600" data-testid="footer-b2b">Area B2B</Link></li>
          <li><Link to="/account" className="hover:text-amber-600">I miei ordini</Link></li>
        </ul>
        <FooterPages />
      </div>
      <div className="md:col-span-2" data-testid="footer-contacts">
        <p className="mb-3 font-display font-semibold"><Link to="/assistenza#contatti" className="hover:text-amber-600">Contatti</Link></p>
        <SocialLinks compact />
        <ul className="mt-5 space-y-3 text-sm">
          {CONTACTS.map((c) => (
            <li key={c.email}>
              <span className="block text-xs text-stone-500">{c.title}</span>
              <a href={`mailto:${c.email}`} className="flex items-center gap-2 font-mono text-stone-700 hover:text-amber-600"><Mail className="h-3.5 w-3.5" />{c.email}</a>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <p className="border-t border-black/5 py-6 text-center text-xs text-stone-500" data-testid="footer-company"><span data-no-translate>© {new Date().getFullYear()} {COMPANY.name} · P.IVA {COMPANY.vat} · {COMPANY.address}</span> · Prezzi al pubblico IVA inclusa · Area B2B IVA esclusa
      <span className="mt-2 flex flex-wrap justify-center gap-x-4 gap-y-1">
        <Link to="/privacy" className="hover:text-amber-600" data-testid="footer-privacy">Privacy</Link>
        <Link to="/cookie" className="hover:text-amber-600" data-testid="footer-cookie">Cookie</Link>
        <Link to="/condizioni-di-vendita" className="hover:text-amber-600" data-testid="footer-terms">Condizioni di vendita</Link>
        <Link to="/note-legali" className="hover:text-amber-600" data-testid="footer-legal-notes">Note legali</Link>
        <button type="button" onClick={openConsent} className="hover:text-amber-600" data-testid="footer-consent">Informativa cookie</button>
      </span>
    </p>
  </footer>
);
